import { render, staticRenderFns } from "./EnPresentacionEliminados.vue?vue&type=template&id=4fde85fa&scoped=true"
import script from "./EnPresentacionEliminados.vue?vue&type=script&lang=js"
export * from "./EnPresentacionEliminados.vue?vue&type=script&lang=js"
import style0 from "./EnPresentacionEliminados.vue?vue&type=style&index=0&id=4fde85fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fde85fa",
  null
  
)

export default component.exports